module.exports = __webpack_public_path__ + "img/discovery.3adf6a82.png";